"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProfileCountry = void 0;
var react_1 = require("react");
var user_1 = require("../user");
var useProfileCountry = function () {
    var _a;
    var data = (0, user_1.useUser)().data;
    return (0, react_1.useMemo)(function () { var _a; return (_a = data === null || data === void 0 ? void 0 : data.profile.getOne.profile.location) === null || _a === void 0 ? void 0 : _a.country; }, [(_a = data === null || data === void 0 ? void 0 : data.profile.getOne.profile.location) === null || _a === void 0 ? void 0 : _a.country]);
};
exports.useProfileCountry = useProfileCountry;
